import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const BritishLifeDEMO = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [leadState, setLeadState] = useState("");
  const [country, setCountry] = useState("gb");
  const [country2, setCountry2] = useState("gb");

  const [companyName, setCompanyName] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [callType, setCallType] = useState("ad_call_british_female"); // State for phone call type

  const [testV2DropdownOption, setTestV2DropdownOption] =
    useState("british_life_leads_dev");
  const [scriptOption, setScriptOption] = useState("bl_standard");
  const [testV2FirstName, setTestV2FirstName] = useState("Test");
  const [testV2City, setTestV2City] = useState("");
  const [testV2InsuranceType, setTestV2InsuranceType] = useState("Income Protection");
  const [testV2CustomerInterest, setTestV2CustomerInterest] = useState("Long-term tax savings");
  const [testV2IntroducerOrWebsite, setTestV2IntroducerOrWebsite] =
    useState("");
  const [testV2PhoneNumber, setTestV2PhoneNumber] = useState("");
  const [testV2LiveTransferPhoneNumber, setTestV2LiveTransferPhoneNumber] =
    useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const human_agent_first_name = "Tom";

    // const fromNumber = "12392081459";
    const fromNumber = "18788844965";
    // const fromNumber = "15489185087";
    const baseUrl =
      "https://initiateretellcall-655075094783.us-central1.run.app";
    let human_agent_id = "0ho90QkFDmsLuKGZ4iAv";
    let lead_id = "123";
    let agent_id = testV2DropdownOption === "british_life_leads_prod" 
      ? "agent_6267be033ac8661249a4fff235" 
      : "agent_0b98170e9dd8ccf42a4a7eaef6";

    let lead_first_name = testV2FirstName;
    let lead_city = "London";
    let human_agent_company_name = "British Life";
    let human_agent_number = `+${testV2LiveTransferPhoneNumber}`;
    let lead_type = testV2DropdownOption === "british_life_leads_dev" ? scriptOption : "bl_oracle_commshare";
    let introducer_or_website = "britishlife.com";
    let insurance_type = testV2InsuranceType;
    // let customer_interest = "interested in long-term tax savings";
    let customer_interest = `interested in ${testV2CustomerInterest}`;
    let lead_tz = "America/Chicago";
    let human_agent_tz = "America/New_York";
    let to_number = testV2PhoneNumber;

    await axios
      .request(
        `${baseUrl}?agent_id=${agent_id}&lead_first_name=${lead_first_name}&human_agent_company_name=${human_agent_company_name}&lead_city=${lead_city}&human_agent_id=${human_agent_id}&lead_type=${lead_type}&lead_id=${lead_id}&human_agent_number=${human_agent_number}&human_agent_first_name=${human_agent_first_name}&introducer_or_website=${introducer_or_website}&insurance_type=${insurance_type}&customer_interest=${customer_interest}&from_number=${fromNumber}&to_number=${to_number}`,
        {
          method: "GET",
          headers: {
            "ngrok-skip-browser-warning": "69420",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => window.alert("Call initiated successfully!"));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              color: '#FFFFFF',
              fontSize: '2rem',
              fontWeight: 'bold',
              margin: '1rem',
            }}>
              British Life DEMO
            </h1>
            <div style={{
              height: '4px',
              width: '100px',
              background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>
          <h3 style={{
            textAlign: 'center',
            color: '#d0d0d0',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto 1.5rem auto'
          }}>
            Testing website for JasperVOCAL's British Life Calling Script
          </h3>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <Select
                value={testV2DropdownOption}
                onChange={(e) => {
                  setTestV2DropdownOption(e.target.value);
                }}
                required
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                  textAlign: "left",
                }}
              >
                <MenuItem value="british_life_leads_dev">
                  British Life Agent Autodialer - Dev & Test
                </MenuItem>
                <MenuItem value="british_life_leads_prod">
                  British Life Agent Autodialer - Prod
                </MenuItem>
              </Select>
              
              {testV2DropdownOption === "british_life_leads_dev" ? (
                <Select
                  value={scriptOption}
                  onChange={(e) => {
                    setScriptOption(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="bl_standard">
                    Standard Live Transfer Script
                  </MenuItem>
                  <MenuItem value="bl_income_protection">
                    Income Protection Leads
                  </MenuItem>
                  <MenuItem value="bl_company_directors">
                    Life Insurance for Company Directors
                  </MenuItem>
                </Select>
              ) : (
                <div style={{
                  backgroundColor: '#f5f5f5',
                  padding: '12px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  Script options are only available for Dev & Test environment
                </div>
              )}
              
              <TextField
                autoFocus
                label="First Name"
                type="text"
                fullWidth
                variant="filled"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                }}
                value={testV2FirstName}
                onChange={(e) => setTestV2FirstName(e.target.value)}
                required
              />
              
              <TextField
                label="Insurance Type"
                type="text"
                fullWidth
                variant="filled"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                }}
                value={testV2InsuranceType}
                onChange={(e) => setTestV2InsuranceType(e.target.value)}
                required
              />
              
              <TextField
                label="Customer Interest"
                type="text"
                fullWidth
                variant="filled"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                }}
                value={testV2CustomerInterest}
                onChange={(e) => setTestV2CustomerInterest(e.target.value)}
                required
              />
              <div style={{ marginTop: '8px' }}>
                <p style={{ margin: '0 0 8px 0', color: '#FFFFFF', fontWeight: '500', textAlign: 'left' }}>
                  <b>Your phone number</b>
                </p>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl sx={{ flex: { sm: '0 0 25%' } }}>
                    <Select
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      required
                    >
                      <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                      <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                      <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                    </Select>
                  </FormControl>
                  <Box sx={{ flex: { sm: '1' } }}>
                    <PhoneInput
                      country={country}
                      value={testV2PhoneNumber}
                      disableDropdown={true}
                      disableCountryGuess={true}
                      onChange={setTestV2PhoneNumber}
                      enableLongNumbers={true}
                      inputStyle={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                        height: "56px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                      }}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      required
                    />
                  </Box>
                </Stack>
              </div>
              
              <div style={{ marginTop: '8px' }}>
                <p style={{ margin: '0 0 8px 0', color: '#FFFFFF', fontWeight: '500', textAlign: 'left' }}>
                  <b>Live transfer phone number</b>
                </p>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl sx={{ flex: { sm: '0 0 25%' } }}>
                    <Select
                      value={country2}
                      onChange={(e) => setCountry2(e.target.value)}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      required
                    >
                      <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                      <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                      <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                    </Select>
                  </FormControl>
                  <Box sx={{ flex: { sm: '1' } }}>
                    <PhoneInput
                      country={country2}
                      value={testV2LiveTransferPhoneNumber}
                      disableDropdown={true}
                      disableCountryGuess={true}
                      onChange={setTestV2LiveTransferPhoneNumber}
                      enableLongNumbers={true}
                      inputStyle={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                        height: "56px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                      }}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      required
                    />
                  </Box>
                </Stack>
              </div>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 30px',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                    background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Click here to receive the DEMO call
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',

                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                {/* Text Content */}
                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  After clicking to receive the DEMO call, you will receive a call
                  from the following phone number:
                  <b style={{ color: '#005a9c' }}> +1 (878) 884-4965</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
